<template>
    <div class="e-tv-preview" :class="[`view-` + view, `theme-` + theme, { 'iframe-mode': iframeMode }]">
        <b-dropdown class="options" variant="light" right :no-caret="true">
            <template v-slot:button-content>
                <template v-if="view === 'landscape'"><span v-tr>Landscape|Paysage</span></template>
                <template v-else-if="view === 'portrait'"><span v-tr>Portrait|Portrait</span></template>
                <template v-else-if="view === 'fullscreen'"><span v-tr>Fullscreen|Plein écran</span></template>
                <i class="fas fa-caret-down ml-1"/>
            </template>
            <b-dropdown-item @click="view = 'landscape'" v-if="view !== 'landscape'">
                <i class="fas fa-image-landscape"></i> <span v-tr>Landscape|Paysage</span>
            </b-dropdown-item>
            <b-dropdown-item @click="view = 'portrait'" v-if="view !== 'mobile'">
                <i class="fas fa-image-portrait"></i> <span v-tr>Portrait|Portrait</span>
            </b-dropdown-item>
            <b-dropdown-item @click="view = 'fullscreen'" v-if="!noFullscreen && view !== 'fullscreen'">
                <i class="fas fa-expand"></i> <span v-tr>Fullscreen|Plein écran</span>
            </b-dropdown-item>
        </b-dropdown>
        <div class="content" :style="contentStyle">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: `e-tv-preview`,
        props: {
            defaultView: { type: String, default: `landscape` },
            value: { type: String },
            theme: { type: String, default: `dark` },
            iframeMode: { type: Boolean, default: false },
            noUserSelect: { type: Boolean, default: false },
            noFullscreen: { type: Boolean, default: false },
            noMobile: { type: Boolean, default: false },
            contentStyle: {}
        },
        data() {
            return {
                view: `landscape`,
                fullscreen: false
            }
        },
        mounted() {
            this.view = this.defaultView;

            if (this.noMobile && this.view === `portrait`) {
                this.view = `portrait`;
            }
            if (this.noTablet && this.view === `landscape`) {
                this.view = `landscape`;
            }
            if (this.noFullscreen && this.view === `fullscreen`) {
                this.view = `fullscreen`;
            }
        },
        watch: {
            view() {
                this.$emit(`input`, this.view);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .e-tv-preview {
        border: 2px solid #ccc;
        border-radius: 5px;
        background-color: white;
        position: relative;
        width: 750px;
        margin: 0 auto 70px;
        transition: top 500ms, width 500ms, height 500ms, margin 500ms;
        display: block;
        flex-direction: column;

        .options {
            position: absolute;
            top: -23px;
            left: calc(50% - 60px);
            margin: 0;

            ::v-deep .btn {
                height: 21px;
                width: 120px;
                padding: 0 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                color: white;
                font-weight: 400;
                border: 1px solid #555;
                background: linear-gradient(to bottom, #333, #444);
            }

            z-index: 1;
        }

        &.no-select {
            user-select: none !important;
        }

        &.view-fullscreen {
            position: fixed;
            z-index: 999;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 0;

            .options {
                top: 5px;
            }
        }

        &.view-portrait,
        &.view-landscape {
            top: 25px;
            left: 15px;
            background: black;

            &:before {
                content: "";
                display: block;
                position: absolute;
                top: -25px;
                left: -25px;
                width: 100%;
                height: 100%;
                border: 25px solid white;
                border-bottom-width: 35px;
                border-radius: 5px;
                box-sizing: content-box;
                pointer-events: none;
                box-shadow: inset 0 0 0 2px #ddd, 0 0 0 2px #ddd;
                background: none;
                opacity: 1;
                z-index: 1;
            }

            &:after {
                content: "";
                display: block;
                position: absolute;
                bottom: -20px;
                right: 10px;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background-color: #03f6f6;
                box-shadow: 0 0 5px #03f6f6;
                box-sizing: content-box;
                pointer-events: none;
                z-index: 1;
            }

            &.theme-dark {
                &:before {
                    border-color: #191919;
                    box-shadow: inset 0 0 10px rgba(black, 0.5), 0 0 0 2px #505050, 0 0 20px rgba(0, 0, 0, 0.5);
                }
            }
        }

        &.view-landscape {
            width: 960px;
            height: 540px;
        }

        &.view-portrait {
            width: 540px;
            height: 960px;
        }

        .header {
            min-height: 30px;
            max-height: 30px;
            text-align: left;
            color: #777;
            font-weight: 500;
            background-color: #fafafa;
            border-bottom: 2px solid #ccc;
            padding: 3px 6px;
            flex: 1;

            > .dropdown {
                float: right;
            }

            > .dropdown ::v-deep .btn,
            .btn {
                background: transparent;
                border: none;
                color: #555;
                line-height: 26px;
                width: 26px;
                height: 26px;
                top: -1px;
                right: -5px;
                padding: 0;
                border-radius: 0;

                .fas {
                    font-size: 14px;
                }

                &:hover {
                    background-color: rgba(0, 0, 0, 0.1);
                }
                &:active {
                    background-color: rgba(0, 0, 0, 0.2);
                }
            }
        }

        .content {
            width: 100%;
            height: 100%;
            overflow-y: auto;
            margin: 0;
            padding: 0;
        }

        &.iframe-mode {
            .content {
                overflow: hidden;

                iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                    margin: 0;
                    padding: 0;
                }
            }
        }
    }
</style>
